<template>
  <div class="h-screen bg-access_point-300 flex flex-col container">
    <HeaderLogin title="ACCESS POINT" sub-title="seguro e fácil" />
    <div
      class="flex items-center w-full flex-col bg-white absolute bottom-0 login"
    >
      <LoginForm class="z-10" />
    </div>
    <img src="@/assets/background_image.png" class="img z-1 w-full" />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import LoginForm from '@/components/LoginForm.vue';
import HeaderLogin from '@/components/Header/HeaderLogin.vue';

export default defineComponent({
  name: 'LoginView',
  components: { LoginForm, HeaderLogin },
});
</script>

<style>
:root {
  --custom-height: 65%;
}
.container {
  position: relative;
  width: 100%;
  height: 100vh;

  @media (min-width: 1200px) {
    width: 450px;
  }
}

.login {
  height: var(--custom-height);
}

.img {
  position: absolute;
  left: 50%;
  transform: translate(-50%);

  @media (min-width: 576px) {
    bottom: calc(var(--custom-height) - 100px);
  }

  @media (max-width: 576px) {
    bottom: calc(var(--custom-height) - 57px);
  }
}
</style>
